const runIterableEmailIdKey = require("./runIterableEmailIdKey");

/**
 * @param emailId {string}
 */
module.exports = function runSetIterableEmailIdToTheSessionStorage(emailId) {
  window.sessionStorage.setItem(runIterableEmailIdKey(), emailId);
};
